import React from 'react';
import { DAYS_OF_THE_WEEK } from "../../../../Helpers/DateTimeHelper";
import Tooltip from "@mui/material/Tooltip";
import AvailabilityDay from "../Inputs/AvailabilityDay";

const AvailabilitySection = (props) => {
    const handleChange = (day, daySlots) => {
        let updatedAvailability = {...props.config.availability};
        updatedAvailability[day] = daySlots;
        props.onChange('availability', updatedAvailability);
    }

    return (<>
        <h5>
            Regular Hours

            <Tooltip
                title="Add hours in the format HH:MM-HH:MM for e.g. 09:00-17:30, please leave blank when unavailable."
            >
                <a className="form-row-tooltip">
                    <i className="fa fa-info-circle"/>
                </a>
            </Tooltip>
        </h5>

        <div className="grid-x form-row amenity-availability-grid">
            {DAYS_OF_THE_WEEK.map(day => (
                <AvailabilityDay
                    key={day}
                    day={day}
                    daySlots={props.config.availability[day] ?? []}
                    onChange={handleChange}

                    allAvailability={props.config.availability ?? {}}
                    onWholeWeekAvailabilityChange={(updatedSlots) => { props.onChange('availability', updatedSlots);}}
                />
            ))}
        </div>
    </>);
};

AvailabilitySection.propTypes = {};

AvailabilitySection.defaultProps = {};

export default AvailabilitySection;
